export default {
    namespaced: true,

    state: () => ({
        integration: {},
        integrations:[],
        servers: [],
        server: {},
    }),

    mutations: {
        STORE_INTEGRATIONS(state, integrations) {
            state.integrations = integrations
        },

        STORE_INTEGRATION(state, integration) {
            state.integration = integration
        },

        STORE_SERVER(state, server) {
            state.server = server
        },

        STORE_SERVERS(state, servers) {
            state.servers = servers
        },
    },

    actions: {},
};
